import { render } from "./iconTabs.vue?vue&type=template&id=a0b7e722"
import script from "./iconTabs.vue?vue&type=script&lang=js"
export * from "./iconTabs.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__